import jsPDF from 'jspdf'
import { applyPlugin } from 'jspdf-autotable'
import { QuoteQuantityType } from '../../../quote/component/quoteConstants'

import currency from '../../../common/service/currency.js'

// jspdf-autotable 5 no longer patches jsPDF on import; doc.autoTable below needs this.
applyPlugin(jsPDF)

const quoteHeaderSection = docData => {
  const doc = docData.doc

  let bodyRows = []

  for (const section of docData.job.quote.sections) {
    let showTitle = true
    for (const [i, talent] of section.talent.entries()) {
      if (talent.quantity) {
        const quantity = talent.usesQuantities ? talent.days + ' ' + talent.quantityDisplayType : ''
        bodyRows.push([
          showTitle ? section.sectionTitle : '',
          talent.talentName,
          talent.quantity,
          currency(talent.markup),
          quantity,
          { content: currency(talent.quoted), styles: { halign: 'right' } },
        ])
        showTitle = false
      }
      if (talent.narrative && talent.showNarrative) {
        bodyRows.push(['', { content: talent.narrative, colspan: 5, styles: { fontStyle: 'italic', fontSize: 8 } }])
      }
      if (i === section.talent.length - 1 && section.talent.filter(talent => talent.quantity > 0).length > 0) {
        bodyRows.push([
          '',
          '',
          '',
          '',
          section.sectionTitle + ' Total',
          {
            content: currency(section.talent.reduce((acc, current) => acc + current.quoted, 0)),
            styles: { halign: 'right' },
          },
        ])
      }
    }
  }

  bodyRows.push([
    { content: '', colSpan: 4 },
    'Sub total',
    { content: currency(docData.job.quote.totalQuoted), styles: { halign: 'right' } },
  ])
  bodyRows.push([
    { content: '', colSpan: 4 },
    'GST 10%',
    { content: currency(docData.job.quote.gst), styles: { halign: 'right' } },
  ])
  bodyRows.push([
    { content: '', colSpan: 4 },
    'Grand Total',
    { content: currency(docData.job.quote.grandTotal), styles: { halign: 'right' } },
  ])
  if (docData.job.quote.optionalAdditions) {
    bodyRows.push([{ content: '', colSpan: 4 }, 'Optional Additions'])
    bodyRows.push([{ content: '', colSpan: 4 }, { content: docData.job.quote.optionalAdditions }])
  }

  doc.autoTable({
    head: [['Category', 'Item', 'Units', 'Price', 'Quantity', 'Total']],
    body: bodyRows,
    startY: docData.yAxis,
    theme: 'plain',
    didParseCell: cell => {
      if (cell.row.raw[1] === '' || cell.row.raw[1] === 'Optional Additions') {
        cell.row.cells[4].styles.fontStyle = 'bold'
      }
    },
    willDrawCell: data => {
      if (data.row.raw[1] === '') {
        doc.setLineWidth(0.5)
        doc.line(data.cell.x, data.cell.y, data.cell.x + data.column.width, data.cell.y)
        doc.line(
          data.cell.x,
          data.cell.y + data.cell.height,
          data.cell.x + data.column.width,
          data.cell.y + data.cell.height
        )
      }
    },
  })

  doc.autoTable({
    body: [
      [
        {
          content:
            'Terms & Conditions\n\n' +
            'By accepting this quote you agree to the following terms:\n\n' +
            '1. This quote is based on the bried provided. The Grand Total figure is what we believe is required to achieve the desired outcome. The breakdown of days and activities are provided as a guide only.  You are liable for the Grand Total amount.\n\n' +
            '2. Our objective is to deliver the Project within the agreed budget. In order to achieve this objective we reserve the right to redistribute the funding and hours allocated to a particular line to another or associated activity without advising you.\n\n' +
            '3. You accept that your final product may include intellectual property rights of others such as actors and voice overs. It is your responsibility to ensure these rights are not breached and that you will be held liable should a breach occur.\n\n' +
            '4. Any materials provided to us, are free of any intellectual property restrictions and you indemnify Beebs Vision Pty Ltd from all legal.',
          styles: { textColor: '#C8C8C8' },
        },
      ],
    ],
    theme: 'plain',
  })

  return docData
}

export default quoteHeaderSection
